import { useMutation } from "@tanstack/react-query";
import { UPLOAD_URL } from "../util/constants";
import useApi from "./useApi";

const useAdminUploadImage = (token: string) => {
    const { register } = useApi<any>(`${UPLOAD_URL}/upload/${token}`);

    return useMutation({
        mutationFn: (image: FormData) => register(image)
    })
}

export default useAdminUploadImage;